<template>
  <el-dialog
    v-model="visible"
    title="Nuevo usuario"
    width="55%"
    center
    @close="closeModal"
  >
    <div class="container">
      <el-form
        ref="formRef"
        :model="user"
        :rules="formRules"
        size="default"
      >
        <el-row :gutter="20">
          <el-form-item prop="Usuario">
            <custom-input
              v-model="user.Usuario"
              :label="'Usuario'"
              :settings="{
                placeholder: 'Ingesar usuario',
                maxlength: 50,
              }"
            ></custom-input>
          </el-form-item>
          <el-form-item style="margin-left: 2%">
            <el-col>
              <div class="custom-label">Activo</div>
              <el-switch v-model="user.Activo" />
            </el-col>
          </el-form-item>
        </el-row>
        <el-row
          :gutter="20"
          class="input-margin"
        >
          <el-form-item prop="Nombre">
            <custom-input
              v-model="user.Nombre"
              :label="'Nombre'"
              :settings="{
                placeholder: 'Ingresar nombre',
              }"
            ></custom-input>
          </el-form-item>
          <el-form-item prop="Apellido">
            <custom-input
              v-model="user.Apellido"
              :label="'Apellido'"
              :settings="{
                placeholder: 'Ingresar apellido',
              }"
            ></custom-input>
          </el-form-item>
        </el-row>
        <el-row
          :gutter="20"
          class="input-margin"
        >
          <el-form-item prop="Email">
            <custom-input
              v-model="user.Email"
              :label="'Email'"
              :settings="{
                placeholder: 'Ingresar email',
              }"
            ></custom-input>
          </el-form-item>
          <el-form-item prop="TelefonoCelular">
            <custom-input
              v-model="user.TelefonoCelular"
              :label="'Celular'"
              :settings="{
                placeholder: 'Ingresar celular',
              }"
            ></custom-input>
          </el-form-item>
        </el-row>
        <el-row
          :gutter="20"
          class="input-margin"
        >
          <el-form-item prop="TelefonoLinea">
            <custom-input
              v-model="user.TelefonoLinea"
              :label="'Tel. Línea'"
              :settings="{
                placeholder: 'Ingresar teléfono de línea',
              }"
            ></custom-input>
          </el-form-item>
          <el-form-item prop="Interno">
            <custom-input
              v-model="user.Interno"
              :label="'Interno'"
              :settings="{
                placeholder: 'Ingresar interno',
              }"
            ></custom-input>
          </el-form-item>
        </el-row>
        <el-row
          :gutter="20"
          class="input-margin"
        >
          <el-col :span="20">
            <el-form-item prop="Password">
              <div class="custom-label">Contraseña</div>
              <el-input
                v-model="user.Password"
                type="password"
                placeholder="Ingresar contraseña"
                show-password
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          :gutter="24"
          class="input-margin"
        >
          <el-col :span="24">
            <div
              class="custom-label"
              style="margin-bottom: 10px"
            >
              Roles
            </div>
            <el-checkbox-group v-model="user.Roles">
              <el-row :gutter="20">
                <el-col
                  v-for="(column, colIndex) in roleColumns"
                  :key="'col-' + colIndex"
                  :span="6"
                >
                  <div class="role-column">
                    <el-checkbox
                      v-for="role in column"
                      :key="role.Codigo"
                      :label="role"
                      class="custom-checkbox"
                    >
                      {{ role.Descripcion }}
                    </el-checkbox>
                  </div>
                </el-col>
              </el-row>
            </el-checkbox-group>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="20">
            <div class="custom-label">Puesto</div>
            <el-checkbox-group v-model="user.PuestoUsuario">
              <el-checkbox
                v-for="puesto in puestoList"
                :key="puesto.Codigo"
                :label="puesto"
                >{{ puesto.Descripcion }}
              </el-checkbox>
            </el-checkbox-group>
          </el-col>
        </el-row>
        <el-row
          :gutter="24"
          class="input-margin"
        >
          <custom-input-number
            v-model.number="user.Comision"
            :label="'% Comisión'"
            :spanColumn="12"
            :settings="{
              placeholder: '% Comisión',
              min: 0,
              precision: 2,
              step: 0.01,
              controls: false,
            }"
          />
        </el-row>
        <el-divider></el-divider>
        <div style="margin: 40px 20px">
          <div
            class="custom-label"
            style="margin-bottom: 10px"
          >
            Usuarios relacionados
          </div>
          <el-transfer
            v-model="user.UsuariosRelacionados"
            :data="usuariosDisponibles"
            :props="transferProps"
            filterable
            filter-placeholder="Buscar usuario"
          >
          </el-transfer>
        </div>
      </el-form>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button
          type="primary"
          @click="saveUser"
          >Guardar</el-button
        >
        <el-button @click="closeModal">Cancelar</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import {
  ref,
  reactive,
  onBeforeMount,
  computed,
} from 'vue';
import { storeToRefs } from 'pinia';
import CustomInput from '@/shared/components/custom_input.vue';
import CustomInputNumber from '@/shared/components/custom_input_number.vue';
import { useUserStore } from '../stores/user_store.js';
import { usePuestoStore } from '@/stores/puesto.js';
import { useRolStore } from '@/stores/rol.js';
import { useMessageError } from '@/shared/composables/message_error.js';
import { useMessageSuccess } from '@/shared/composables/message_success.js';
import { useLoading } from '@/shared/composables/loading.js';
import { ElNotification } from 'element-plus';

const puestoStore = usePuestoStore();
const rolStore = useRolStore();
const userStore = useUserStore();
const { resetUser, newUserHTTP, firstUsers, loadUsuariosDisponibles } = userStore;
const { firstRol } = rolStore;
const { firstPuesto } = puestoStore;
const { user, usuariosDisponibles } = storeToRefs(userStore);
const { rolList } = storeToRefs(rolStore);
const { puestoList } = storeToRefs(puestoStore);
const visible = ref(false);
const formRef = ref(null);
const formRules = reactive({
  Nombre: [{ required: true, message: 'Ingresar nombre', trigger: 'blur' }],
  Usuario: [{ required: true, message: 'Ingresar usuario', trigger: 'blur' }],
  Apellido: [{ required: true, message: 'Ingresar apellido', trigger: 'blur' }],
  Password: [
    { required: true, message: 'Ingresar contraseña', trigger: 'blur' },
    { min: 4, message: 'La contraseña debe tener al menos 4 caracteres', trigger: 'blur' },
  ],
  Email: [{ type: 'email', message: 'Ingrese un email válido', trigger: 'blur' }],
});
const roleColumns = computed(() => {
  const allRoles = rolList.value || [];

  const col1Names = ['usuarios', 'configuracion', 'prospectos', 'ejecutivo de ventas'];
  const col2Names = ['recursos', 'cilindros', 'suajes', 'materiales'];
  const col3Names = ['solicitud', 'cotizacion', 'propuestas', 'et', 'ot'];

  const getRolesByNames = (names) => {
    return names
      .map((name) => allRoles.find((r) => r.Descripcion?.toLowerCase() === name))
      .filter(Boolean);
  };

  const col1 = getRolesByNames(col1Names);
  const col2 = getRolesByNames(col2Names);
  const col3 = getRolesByNames(col3Names);

  const usedIds = new Set([...col1, ...col2, ...col3].map((r) => r.Codigo));
  const customRoles = allRoles.filter((r) => !usedIds.has(r.Codigo));

  const columns = [col1, col2, col3];

  const chunkSize = 5;
  for (let i = 0; i < customRoles.length; i += chunkSize) {
    columns.push(customRoles.slice(i, i + chunkSize));
  }

  return columns.filter((col) => col.length > 0);
});
const emit = defineEmits(['closed']);
const transferProps = {
  key: 'Codigo',
  label: 'Descripcion',
};
const closeModal = () => {
  resetUser();
  resetFormValidation();
  visible.value = false;
  emit('closed');
};

onBeforeMount(() => {
  firstPuesto();
  firstRol();
  loadUsuariosDisponibles();
});

const resetFormValidation = () => {
  if (formRef.value) {
    formRef.value.resetFields();
  }
};

const saveUser = async () => {
  formRef.value.validate(async (valid) => {
    if (valid) {
      try {
        useLoading().openLoading();
        await newUserHTTP();
        useMessageSuccess().open(`Los datos se guardaron existosamente!`);
        closeModal();
      } catch (err) {
        useMessageError().open(`Ha ocurrido un error al intentar guardar los datos.`);
      } finally {
        useLoading().closeLoading();
        await firstUsers();
      }
    } else {
      ElNotification({
        title: 'Nuevo usuario',
        message: 'Por favor, revise los campos ingresados.',
        type: 'warning',
      });
    }
  });
};
</script>

<style scoped>
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  margin: 5%;
}

.container {
  height: 100%;
  overflow-y: auto !important;
  overflow-x: hidden;
}

.el-form {
  margin-top: 0;
  padding-left: 10px;
}

/* Elimina los márgenes de los el-form-item */
.el-form-item {
  margin-top: 0;
  margin-bottom: 0;
}
.input-margin {
  margin-top: 3%;
}
.full-width {
  width: 100%;
}
.custom-label {
  font-weight: 700;
  color: #111;
}
:deep(.el-transfer-panel) {
  width: 250;
}
.role-column {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.custom-checkbox {
  margin-right: 0 !important;
  height: auto;
}
</style>
